import * as Api from '@/request/api/defaultApi';
import { useAppStore } from '@/store/modules/app';

// 埋点统一入口：调用方只给事件名，渠道信息、版本号前缀、两种上报格式都收在这里。
//
// 为什么不让调用方直接调 Api.TrackLog / Api.TrackLogQuery：
//   1. 渠道信息要从 ClientInfo 解构，C++ 渠道接口超时时 ClientInfo 为 null，各调用点直接解构会抛 TypeError，
//      同样会中断业务流程——判空只在这里做一次；
//   2. 版本号的 WA_ 前缀（日志平台按前缀统计）只拼一次，不会漏；
//   3. 哪些动作要额外发一份路径形式，集中在下面的常量里，不靠各调用点自觉写两行。

// 除 query 形式外还要再发一份路径形式的动作（口径由日志平台决定）
const PATH_FORM_KEYS = ['login', 'loginsuccess', 'payUI'];

/**
 * 上报埋点
 * @param key 埋点事件名，如 appStartUp / login / paySuccess
 *
 * 返回 void：埋点是旁路行为，调用方不要 await、也不需要处理失败
 * （Api 层已经把异常吃掉了，这里不会抛，也不会 reject）。
 */
export function track(key: string): void {
    const appStore = useAppStore();
    const clientInfo: any = appStore.ClientInfo;

    // 渠道信息拿不到就跳过：没有 channel / guid 的埋点数据对统计没意义
    if (!clientInfo) {
        console.warn('[埋点] 渠道信息缺失，跳过上报', key);
        return;
    }

    const { client_channel, client_guid, client_sys_ver, client_version } = clientInfo;
    const ver = `WA_${client_version}`;

    void Api.TrackLogQuery(key, client_channel, ver, client_sys_ver, client_guid);

    if (PATH_FORM_KEYS.includes(key)) {
        void Api.TrackLog(`/${key}/${client_channel}/${ver}/${client_sys_ver}/${client_guid}`);
    }
}
